import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {ICreditCardAddResponse, PackagePaymentMethodInterface, PaymentMethodInterface} from '../interface/payment-method.interface';
import { getHttpHeaders } from '../../../shared/utils/http.utils';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {AdminSubscriptionInterface} from '../../components/my-info/shared/interface/admin-subscription.interface';
import {
  AdminBoardChecklistStateInterface,
  AdminBoardCloneResultInterface,
  AdminBoardStatusInterface,
} from '../../components/my-info/shared/interface/admin-board-status.interface';


const baseUrl = environment.API_URL;

@Injectable({
  providedIn: 'root'
})
export class SuperService {

  constructor(private http: HttpClient) { }

  public getTransactions(
    customerId: number,
    search: string,
    year: string,
    ): Observable<any> {
      let params = new HttpParams();
      if (search !== '') {
        params = params.set('search', search);
      }
      if (year !== null) {
        params = params.set('year', year);
      }

      return this.http.get<any>(`${baseUrl}/jobatory/customers/${customerId}/transactions`,
      { params, headers: getHttpHeaders() }
    );
  }

  public addPaymentMethod(customerId: number): Observable<ICreditCardAddResponse> {
    return this.http.get<ICreditCardAddResponse>(
      `${baseUrl}/jobatory/customers/${customerId}/payment-methods/create`,
      { headers: getHttpHeaders() }
    );
  }

  public getPaymentMethods(customerId: number): Observable<PaymentMethodInterface[]> {
    return this.http.get<PaymentMethodInterface[]>(`${baseUrl}/jobatory/customers/${customerId}/payment-methods`,
      { headers: getHttpHeaders() }
    );
  }

  public setDefaultPaymentMethod(customersId: number, creditCardId: string): Observable<PaymentMethodInterface> {
    return this.http.post<PaymentMethodInterface>(
      `${baseUrl}/jobatory/customers/${customersId}/payment-methods/set-default`,
      { credit_card_id: creditCardId },
      { headers: getHttpHeaders() }
    );
  }

  public getConfigData(): any {
    return this.http.get<any>(`${baseUrl}/jobatory`);
  }

  public getStripeKeys(): Observable<any> {
    return this.http.get<any>(`${baseUrl}/stripe/api-keys`,
      { headers: getHttpHeaders() }
    );
  }

  // JOB-4274 - Admin Board setup checklist + public links
  public getAdminBoardStatus(): Observable<AdminBoardStatusInterface> {
    return this.http.get<AdminBoardStatusInterface>(`${baseUrl}/admin-board/setup-status`,
      { headers: getHttpHeaders() }
    );
  }

  // JOB-4274 - copy this instance's settings, packages and zones onto its
  // sandbox. Slow by nature, so the caller shows progress.
  public cloneToTestEnvironment(): Observable<AdminBoardCloneResultInterface> {
    return this.http.post<AdminBoardCloneResultInterface>(
      `${baseUrl}/admin-board/clone-to-test`,
      {},
      { headers: getHttpHeaders() }
    );
  }

  // JOB-4274 - tick or un-tick a checklist item by hand. Returns the whole
  // checklist back so the counts and progress bar stay in step with the server.
  public setAdminBoardChecklistItem(key: string, completed: boolean):
    Observable<AdminBoardChecklistStateInterface> {
    return this.http.post<AdminBoardChecklistStateInterface>(
      `${baseUrl}/admin-board/checklist/${key}`,
      { completed },
      { headers: getHttpHeaders() }
    );
  }

  public addStripeKeys(data): Observable<any> {
    return this.http.post(`${baseUrl}/stripe/store-api-keys`, {"keys": data}, {
      headers: getHttpHeaders(),
    });
  }

  public getCustomerSpreadsheets(): Observable<any> {
    const params = new HttpParams();

    return this.http.get<any>(`${baseUrl}/manage-customers`,
      { params, headers: getHttpHeaders() }
    );
  }

  public uploadCustomerSpreadsheet(spreadsheet: File): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('spreadsheet', spreadsheet , spreadsheet.name);

    return this.http.post(`${baseUrl}/manage-customers/upload`, formData);
  }

  public activateCustomers(id: number): Observable<any> {
    return this.http.get(`${baseUrl}/manage-customers/activate`);
  }

  public activationProgress(): Observable<any> {
    return this.http.get(`${baseUrl}/manage-customers/activation-progress`);
  }

  public getSubscription(customerId: number): Observable<AdminSubscriptionInterface> {
    return this.http.get<AdminSubscriptionInterface>(`${baseUrl}/jobatory/customers/${customerId}/subscription-details`,
      { headers: getHttpHeaders() }
    );
  }

  public getCustomerPackagePaymentStatus(customerId: number): Observable<PackagePaymentMethodInterface> {
    return this.http.get<PackagePaymentMethodInterface>(`${baseUrl}/jobatory/customers/${customerId}/package-payment-status`,
      { headers: getHttpHeaders() }
    );
  }

  loadCustomerPaymentStatus() {

  }
}
